/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as WelcomeRouteImport } from "./routes/welcome"
import { Route as WaitlistRouteImport } from "./routes/waitlist"
import { Route as PsychologicalContextRouteImport } from "./routes/psychological-context"
import { Route as DevRouteImport } from "./routes/dev"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as AboutRouteImport } from "./routes/about"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as TraitsIndexRouteImport } from "./routes/traits/index"
import { Route as TimelineEventsIndexRouteImport } from "./routes/timeline-events/index"
import { Route as SongsIndexRouteImport } from "./routes/songs/index"
import { Route as ReflectionsIndexRouteImport } from "./routes/reflections/index"
import { Route as QuizIndexRouteImport } from "./routes/quiz/index"
import { Route as PeopleIndexRouteImport } from "./routes/people/index"
import { Route as JournalIndexRouteImport } from "./routes/journal/index"
import { Route as ContextSuggestionsIndexRouteImport } from "./routes/context-suggestions/index"
import { Route as ChatIndexRouteImport } from "./routes/chat/index"
import { Route as AuthIndexRouteImport } from "./routes/auth/index"
import { Route as TimelineEventsTimelineEventIdRouteImport } from "./routes/timeline-events/$timelineEventId"
import { Route as SongsUserSongIdRouteImport } from "./routes/songs/$userSongId"
import { Route as SetupProfileRouteImport } from "./routes/setup/profile"
import { Route as PeoplePersonIdRouteImport } from "./routes/people/$personId"
import { Route as JournalJournalEntryIdRouteImport } from "./routes/journal/$journalEntryId"
import { Route as ContextSuggestionsSuggestionIdRouteImport } from "./routes/context-suggestions/$suggestionId"
import { Route as ChatChatRoomIdRouteImport } from "./routes/chat/$chatRoomId"
import { Route as AuthLogoutRouteImport } from "./routes/auth/logout"
import { Route as AuthAdminRouteImport } from "./routes/auth/admin"
import { Route as AuthAccountRouteImport } from "./routes/auth/account"
import { Route as TherapySessionIndexRouteImport } from "./routes/therapy/session/index"
import { Route as TherapySessionTherapySessionIdRouteImport } from "./routes/therapy/session/$therapySessionId"

const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: "/waitlist",
  path: "/waitlist",
  getParentRoute: () => rootRouteImport,
} as any)
const PsychologicalContextRoute = PsychologicalContextRouteImport.update({
  id: "/psychological-context",
  path: "/psychological-context",
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: "/dev",
  path: "/dev",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: "/about",
  path: "/about",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const TraitsIndexRoute = TraitsIndexRouteImport.update({
  id: "/traits/",
  path: "/traits/",
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineEventsIndexRoute = TimelineEventsIndexRouteImport.update({
  id: "/timeline-events/",
  path: "/timeline-events/",
  getParentRoute: () => rootRouteImport,
} as any)
const SongsIndexRoute = SongsIndexRouteImport.update({
  id: "/songs/",
  path: "/songs/",
  getParentRoute: () => rootRouteImport,
} as any)
const ReflectionsIndexRoute = ReflectionsIndexRouteImport.update({
  id: "/reflections/",
  path: "/reflections/",
  getParentRoute: () => rootRouteImport,
} as any)
const QuizIndexRoute = QuizIndexRouteImport.update({
  id: "/quiz/",
  path: "/quiz/",
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: "/people/",
  path: "/people/",
  getParentRoute: () => rootRouteImport,
} as any)
const JournalIndexRoute = JournalIndexRouteImport.update({
  id: "/journal/",
  path: "/journal/",
  getParentRoute: () => rootRouteImport,
} as any)
const ContextSuggestionsIndexRoute = ContextSuggestionsIndexRouteImport.update({
  id: "/context-suggestions/",
  path: "/context-suggestions/",
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: "/chat/",
  path: "/chat/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: "/auth/",
  path: "/auth/",
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineEventsTimelineEventIdRoute =
  TimelineEventsTimelineEventIdRouteImport.update({
    id: "/timeline-events/$timelineEventId",
    path: "/timeline-events/$timelineEventId",
    getParentRoute: () => rootRouteImport,
  } as any)
const SongsUserSongIdRoute = SongsUserSongIdRouteImport.update({
  id: "/songs/$userSongId",
  path: "/songs/$userSongId",
  getParentRoute: () => rootRouteImport,
} as any)
const SetupProfileRoute = SetupProfileRouteImport.update({
  id: "/setup/profile",
  path: "/setup/profile",
  getParentRoute: () => rootRouteImport,
} as any)
const PeoplePersonIdRoute = PeoplePersonIdRouteImport.update({
  id: "/people/$personId",
  path: "/people/$personId",
  getParentRoute: () => rootRouteImport,
} as any)
const JournalJournalEntryIdRoute = JournalJournalEntryIdRouteImport.update({
  id: "/journal/$journalEntryId",
  path: "/journal/$journalEntryId",
  getParentRoute: () => rootRouteImport,
} as any)
const ContextSuggestionsSuggestionIdRoute =
  ContextSuggestionsSuggestionIdRouteImport.update({
    id: "/context-suggestions/$suggestionId",
    path: "/context-suggestions/$suggestionId",
    getParentRoute: () => rootRouteImport,
  } as any)
const ChatChatRoomIdRoute = ChatChatRoomIdRouteImport.update({
  id: "/chat/$chatRoomId",
  path: "/chat/$chatRoomId",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: "/auth/logout",
  path: "/auth/logout",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: "/auth/admin",
  path: "/auth/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: "/auth/account",
  path: "/auth/account",
  getParentRoute: () => rootRouteImport,
} as any)
const TherapySessionIndexRoute = TherapySessionIndexRouteImport.update({
  id: "/therapy/session/",
  path: "/therapy/session/",
  getParentRoute: () => rootRouteImport,
} as any)
const TherapySessionTherapySessionIdRoute =
  TherapySessionTherapySessionIdRouteImport.update({
    id: "/therapy/session/$therapySessionId",
    path: "/therapy/session/$therapySessionId",
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/psychological-context": typeof PsychologicalContextRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/chat/$chatRoomId": typeof ChatChatRoomIdRoute
  "/context-suggestions/$suggestionId": typeof ContextSuggestionsSuggestionIdRoute
  "/journal/$journalEntryId": typeof JournalJournalEntryIdRoute
  "/people/$personId": typeof PeoplePersonIdRoute
  "/setup/profile": typeof SetupProfileRoute
  "/songs/$userSongId": typeof SongsUserSongIdRoute
  "/timeline-events/$timelineEventId": typeof TimelineEventsTimelineEventIdRoute
  "/auth/": typeof AuthIndexRoute
  "/chat/": typeof ChatIndexRoute
  "/context-suggestions/": typeof ContextSuggestionsIndexRoute
  "/journal/": typeof JournalIndexRoute
  "/people/": typeof PeopleIndexRoute
  "/quiz/": typeof QuizIndexRoute
  "/reflections/": typeof ReflectionsIndexRoute
  "/songs/": typeof SongsIndexRoute
  "/timeline-events/": typeof TimelineEventsIndexRoute
  "/traits/": typeof TraitsIndexRoute
  "/therapy/session/$therapySessionId": typeof TherapySessionTherapySessionIdRoute
  "/therapy/session/": typeof TherapySessionIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/psychological-context": typeof PsychologicalContextRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/chat/$chatRoomId": typeof ChatChatRoomIdRoute
  "/context-suggestions/$suggestionId": typeof ContextSuggestionsSuggestionIdRoute
  "/journal/$journalEntryId": typeof JournalJournalEntryIdRoute
  "/people/$personId": typeof PeoplePersonIdRoute
  "/setup/profile": typeof SetupProfileRoute
  "/songs/$userSongId": typeof SongsUserSongIdRoute
  "/timeline-events/$timelineEventId": typeof TimelineEventsTimelineEventIdRoute
  "/auth": typeof AuthIndexRoute
  "/chat": typeof ChatIndexRoute
  "/context-suggestions": typeof ContextSuggestionsIndexRoute
  "/journal": typeof JournalIndexRoute
  "/people": typeof PeopleIndexRoute
  "/quiz": typeof QuizIndexRoute
  "/reflections": typeof ReflectionsIndexRoute
  "/songs": typeof SongsIndexRoute
  "/timeline-events": typeof TimelineEventsIndexRoute
  "/traits": typeof TraitsIndexRoute
  "/therapy/session/$therapySessionId": typeof TherapySessionTherapySessionIdRoute
  "/therapy/session": typeof TherapySessionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/about": typeof AboutRoute
  "/dashboard": typeof DashboardRoute
  "/dev": typeof DevRoute
  "/psychological-context": typeof PsychologicalContextRoute
  "/waitlist": typeof WaitlistRoute
  "/welcome": typeof WelcomeRoute
  "/auth/account": typeof AuthAccountRoute
  "/auth/admin": typeof AuthAdminRoute
  "/auth/logout": typeof AuthLogoutRoute
  "/chat/$chatRoomId": typeof ChatChatRoomIdRoute
  "/context-suggestions/$suggestionId": typeof ContextSuggestionsSuggestionIdRoute
  "/journal/$journalEntryId": typeof JournalJournalEntryIdRoute
  "/people/$personId": typeof PeoplePersonIdRoute
  "/setup/profile": typeof SetupProfileRoute
  "/songs/$userSongId": typeof SongsUserSongIdRoute
  "/timeline-events/$timelineEventId": typeof TimelineEventsTimelineEventIdRoute
  "/auth/": typeof AuthIndexRoute
  "/chat/": typeof ChatIndexRoute
  "/context-suggestions/": typeof ContextSuggestionsIndexRoute
  "/journal/": typeof JournalIndexRoute
  "/people/": typeof PeopleIndexRoute
  "/quiz/": typeof QuizIndexRoute
  "/reflections/": typeof ReflectionsIndexRoute
  "/songs/": typeof SongsIndexRoute
  "/timeline-events/": typeof TimelineEventsIndexRoute
  "/traits/": typeof TraitsIndexRoute
  "/therapy/session/$therapySessionId": typeof TherapySessionTherapySessionIdRoute
  "/therapy/session/": typeof TherapySessionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/psychological-context"
    | "/waitlist"
    | "/welcome"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/logout"
    | "/chat/$chatRoomId"
    | "/context-suggestions/$suggestionId"
    | "/journal/$journalEntryId"
    | "/people/$personId"
    | "/setup/profile"
    | "/songs/$userSongId"
    | "/timeline-events/$timelineEventId"
    | "/auth/"
    | "/chat/"
    | "/context-suggestions/"
    | "/journal/"
    | "/people/"
    | "/quiz/"
    | "/reflections/"
    | "/songs/"
    | "/timeline-events/"
    | "/traits/"
    | "/therapy/session/$therapySessionId"
    | "/therapy/session/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/psychological-context"
    | "/waitlist"
    | "/welcome"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/logout"
    | "/chat/$chatRoomId"
    | "/context-suggestions/$suggestionId"
    | "/journal/$journalEntryId"
    | "/people/$personId"
    | "/setup/profile"
    | "/songs/$userSongId"
    | "/timeline-events/$timelineEventId"
    | "/auth"
    | "/chat"
    | "/context-suggestions"
    | "/journal"
    | "/people"
    | "/quiz"
    | "/reflections"
    | "/songs"
    | "/timeline-events"
    | "/traits"
    | "/therapy/session/$therapySessionId"
    | "/therapy/session"
  id:
    | "__root__"
    | "/"
    | "/about"
    | "/dashboard"
    | "/dev"
    | "/psychological-context"
    | "/waitlist"
    | "/welcome"
    | "/auth/account"
    | "/auth/admin"
    | "/auth/logout"
    | "/chat/$chatRoomId"
    | "/context-suggestions/$suggestionId"
    | "/journal/$journalEntryId"
    | "/people/$personId"
    | "/setup/profile"
    | "/songs/$userSongId"
    | "/timeline-events/$timelineEventId"
    | "/auth/"
    | "/chat/"
    | "/context-suggestions/"
    | "/journal/"
    | "/people/"
    | "/quiz/"
    | "/reflections/"
    | "/songs/"
    | "/timeline-events/"
    | "/traits/"
    | "/therapy/session/$therapySessionId"
    | "/therapy/session/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DashboardRoute: typeof DashboardRoute
  DevRoute: typeof DevRoute
  PsychologicalContextRoute: typeof PsychologicalContextRoute
  WaitlistRoute: typeof WaitlistRoute
  WelcomeRoute: typeof WelcomeRoute
  AuthAccountRoute: typeof AuthAccountRoute
  AuthAdminRoute: typeof AuthAdminRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  ChatChatRoomIdRoute: typeof ChatChatRoomIdRoute
  ContextSuggestionsSuggestionIdRoute: typeof ContextSuggestionsSuggestionIdRoute
  JournalJournalEntryIdRoute: typeof JournalJournalEntryIdRoute
  PeoplePersonIdRoute: typeof PeoplePersonIdRoute
  SetupProfileRoute: typeof SetupProfileRoute
  SongsUserSongIdRoute: typeof SongsUserSongIdRoute
  TimelineEventsTimelineEventIdRoute: typeof TimelineEventsTimelineEventIdRoute
  AuthIndexRoute: typeof AuthIndexRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ContextSuggestionsIndexRoute: typeof ContextSuggestionsIndexRoute
  JournalIndexRoute: typeof JournalIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  QuizIndexRoute: typeof QuizIndexRoute
  ReflectionsIndexRoute: typeof ReflectionsIndexRoute
  SongsIndexRoute: typeof SongsIndexRoute
  TimelineEventsIndexRoute: typeof TimelineEventsIndexRoute
  TraitsIndexRoute: typeof TraitsIndexRoute
  TherapySessionTherapySessionIdRoute: typeof TherapySessionTherapySessionIdRoute
  TherapySessionIndexRoute: typeof TherapySessionIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/welcome": {
      id: "/welcome"
      path: "/welcome"
      fullPath: "/welcome"
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/waitlist": {
      id: "/waitlist"
      path: "/waitlist"
      fullPath: "/waitlist"
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/psychological-context": {
      id: "/psychological-context"
      path: "/psychological-context"
      fullPath: "/psychological-context"
      preLoaderRoute: typeof PsychologicalContextRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev": {
      id: "/dev"
      path: "/dev"
      fullPath: "/dev"
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/about": {
      id: "/about"
      path: "/about"
      fullPath: "/about"
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/traits/": {
      id: "/traits/"
      path: "/traits"
      fullPath: "/traits/"
      preLoaderRoute: typeof TraitsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/timeline-events/": {
      id: "/timeline-events/"
      path: "/timeline-events"
      fullPath: "/timeline-events/"
      preLoaderRoute: typeof TimelineEventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/songs/": {
      id: "/songs/"
      path: "/songs"
      fullPath: "/songs/"
      preLoaderRoute: typeof SongsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reflections/": {
      id: "/reflections/"
      path: "/reflections"
      fullPath: "/reflections/"
      preLoaderRoute: typeof ReflectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/quiz/": {
      id: "/quiz/"
      path: "/quiz"
      fullPath: "/quiz/"
      preLoaderRoute: typeof QuizIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/people/": {
      id: "/people/"
      path: "/people"
      fullPath: "/people/"
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/journal/": {
      id: "/journal/"
      path: "/journal"
      fullPath: "/journal/"
      preLoaderRoute: typeof JournalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/context-suggestions/": {
      id: "/context-suggestions/"
      path: "/context-suggestions"
      fullPath: "/context-suggestions/"
      preLoaderRoute: typeof ContextSuggestionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/chat/": {
      id: "/chat/"
      path: "/chat"
      fullPath: "/chat/"
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/": {
      id: "/auth/"
      path: "/auth"
      fullPath: "/auth/"
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/timeline-events/$timelineEventId": {
      id: "/timeline-events/$timelineEventId"
      path: "/timeline-events/$timelineEventId"
      fullPath: "/timeline-events/$timelineEventId"
      preLoaderRoute: typeof TimelineEventsTimelineEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/songs/$userSongId": {
      id: "/songs/$userSongId"
      path: "/songs/$userSongId"
      fullPath: "/songs/$userSongId"
      preLoaderRoute: typeof SongsUserSongIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/setup/profile": {
      id: "/setup/profile"
      path: "/setup/profile"
      fullPath: "/setup/profile"
      preLoaderRoute: typeof SetupProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/people/$personId": {
      id: "/people/$personId"
      path: "/people/$personId"
      fullPath: "/people/$personId"
      preLoaderRoute: typeof PeoplePersonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/journal/$journalEntryId": {
      id: "/journal/$journalEntryId"
      path: "/journal/$journalEntryId"
      fullPath: "/journal/$journalEntryId"
      preLoaderRoute: typeof JournalJournalEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/context-suggestions/$suggestionId": {
      id: "/context-suggestions/$suggestionId"
      path: "/context-suggestions/$suggestionId"
      fullPath: "/context-suggestions/$suggestionId"
      preLoaderRoute: typeof ContextSuggestionsSuggestionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/chat/$chatRoomId": {
      id: "/chat/$chatRoomId"
      path: "/chat/$chatRoomId"
      fullPath: "/chat/$chatRoomId"
      preLoaderRoute: typeof ChatChatRoomIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/logout": {
      id: "/auth/logout"
      path: "/auth/logout"
      fullPath: "/auth/logout"
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/admin": {
      id: "/auth/admin"
      path: "/auth/admin"
      fullPath: "/auth/admin"
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/account": {
      id: "/auth/account"
      path: "/auth/account"
      fullPath: "/auth/account"
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/therapy/session/": {
      id: "/therapy/session/"
      path: "/therapy/session"
      fullPath: "/therapy/session/"
      preLoaderRoute: typeof TherapySessionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/therapy/session/$therapySessionId": {
      id: "/therapy/session/$therapySessionId"
      path: "/therapy/session/$therapySessionId"
      fullPath: "/therapy/session/$therapySessionId"
      preLoaderRoute: typeof TherapySessionTherapySessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DashboardRoute: DashboardRoute,
  DevRoute: DevRoute,
  PsychologicalContextRoute: PsychologicalContextRoute,
  WaitlistRoute: WaitlistRoute,
  WelcomeRoute: WelcomeRoute,
  AuthAccountRoute: AuthAccountRoute,
  AuthAdminRoute: AuthAdminRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  ChatChatRoomIdRoute: ChatChatRoomIdRoute,
  ContextSuggestionsSuggestionIdRoute: ContextSuggestionsSuggestionIdRoute,
  JournalJournalEntryIdRoute: JournalJournalEntryIdRoute,
  PeoplePersonIdRoute: PeoplePersonIdRoute,
  SetupProfileRoute: SetupProfileRoute,
  SongsUserSongIdRoute: SongsUserSongIdRoute,
  TimelineEventsTimelineEventIdRoute: TimelineEventsTimelineEventIdRoute,
  AuthIndexRoute: AuthIndexRoute,
  ChatIndexRoute: ChatIndexRoute,
  ContextSuggestionsIndexRoute: ContextSuggestionsIndexRoute,
  JournalIndexRoute: JournalIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  QuizIndexRoute: QuizIndexRoute,
  ReflectionsIndexRoute: ReflectionsIndexRoute,
  SongsIndexRoute: SongsIndexRoute,
  TimelineEventsIndexRoute: TimelineEventsIndexRoute,
  TraitsIndexRoute: TraitsIndexRoute,
  TherapySessionTherapySessionIdRoute: TherapySessionTherapySessionIdRoute,
  TherapySessionIndexRoute: TherapySessionIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
